import style from "./index.module.css";
import closeIcon from "assets/images/icons/close-square.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/icon-trash.svg";
import { ReactComponent as ChangeIcon } from "assets/images/icons/icon-edit.svg";
import { ReactComponent as MoreIcon } from "assets/images/icons/icon-more-two.svg";
import add_icon from "assets/images/icons/icon-add.svg";
import more_icon from "assets/images/icons/icon-more-two.svg";
import post_image from "assets/images/icons/icon-gallery-add.svg";
import Table from "components/Table";
import { useEffect, useState, useRef } from "react";
import MoreBtn from "components/MoreBtn";
import apiRequest from "api/axios";
import { BASE_URL, URL } from "constants/urls";
import { useMemo } from "react";

const initialValue = {
  header: [
    {
      content: "Имя сотрудника",
    },
    {
      content: "Логин",
    },
    {
      content: "Номер телефона",
    },
    {
      content: "Профессия",
    },
    {
      content: "телеграм",
    },
    {
      content: (
        <div>
          <img src={more_icon} />
        </div>
      ),
      type: "html",
    },
  ],
  body: [],
};

const collums = [
  "id",
  {
    userProfile: ["avatar", "first_name", "last_name"],
  },
  "username",
  "phone",
  "position",
  "tg_username",
];

const returnStringFromArray = (array) => {
  return array
    .map((item) => {
      if (typeof item === "object") {
        let val = Object.values(item)[0];
        if (Array.isArray(val)) {
          return val.join(",");
        }
      }
      return item;
    })
    .join(",");
};

const Employee = () => {
  const [imagePreview, setImagePreview] = useState(post_image);
  const filePickerRef = useRef(null);
  const [status, setStatus] = useState(false);
  const [data, setData] = useState(initialValue);
  const [pagination, setPagination] = useState({
    per_page: 7,
    page: 1,
    total: null,
  });
//   const productCurrentData = useMemo(() => {
//     if (data.body.length) {
//       const productChunk = data.body.slice(
//         (pag - 1) * page,
//         currentPage * page
//       );
//       return productChunk;
//     }
//     return [];
//   }, [currentPage, data]);
  const previewFile = (e) => {
    const reader = new FileReader();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }

    reader.onload = (readerEvent) => {
      setImagePreview(readerEvent.target.result);
    };
  };
  useEffect(() => {
    (async () => {
      const { data: _data, headers } = await apiRequest.get("/employee", {
        params: {
          fields: returnStringFromArray(collums),
          "per-page": pagination.per_page,
          page: pagination.page,
        },
      });
      const total = headers.get("X-Pagination-Total-Count");
      setPagination((prev) => ({ ...prev, total: Number(total) }));
      let a = _data.data.map((item, index) => {
        const res = [];
        for (let i = 0; i < collums.length; i++) {
          const col = collums[i];

          if (col === "id") continue;

          if (typeof col === "object") {
            Object.entries(col).forEach(([key, value]) => {
              if (key === "userProfile") {
                res.push({
                  content: (
                    <div className={style.name}>
                      <img src={URL + item[value[0]]} />{" "}
                      <p>
                        {item[[value[1]]]} {item[[value[2]]]}
                      </p>
                    </div>
                  ),
                  type: "html",
                });
              }
            });
          }

          if (col in item) {
            res.push({ content: item[col] });
          }
        }

        res.push({
          content: (
            <MoreBtn more={more} more_icon_btn={<MoreIcon />} total={total} />
          ),
          type: "html",
        });

        return res;
      });
      setData({ header: initialValue.header, body: a });
    })();
  }, [pagination.page]);

  const more = [
    {
      text: "Изменить",
      image: <ChangeIcon />,
      id: 1,
    },
    {
      text: "Удалить",
      image: <TrashIcon />,
      id: 2,
    },
  ];

  return (
    <div className={style.wrapper}>
      <div className={style.section_head}>
        <p className={style.title}>Сотрудники</p>
        <button onClick={() => setStatus(true)} className={style.add_btn}>
          <img src={add_icon} alt="icon add" />
          Добавить сотрудника
        </button>
      </div>

      <div className={style.tabel_wrapper}>
        <Table
          currentPage={pagination.page}
          data={data}
          page={pagination.per_page}
          total={pagination.total}
          changeCurrentPage={(page) => setPagination(prev => ({ ...prev, page }))}
        />
      </div>

      {/* POP-UPs  */}
      <div className={status ? "modal" : "modal_hiden_bg"}>
        <div className={status ? "modal_content" : "modal_hiden"}>
          <div className={style.modal_header}>
            <h3 className={style.modal_title}>Новое событие</h3>
            <button
              onClick={() => setStatus(false)}
              className={style.modal_close}
            >
              <img src={closeIcon} alt="closeIcon " />
            </button>
          </div>
          <div className={style.modal_body}>
            <form className={style.modal_form}>
              <label className={style.form_label_max}>
                <div className={style.post_image}>
                  <div className={style.img_gallery}>
                    <img
                      src={imagePreview}
                      className={
                        imagePreview !== post_image ? style.added_image : ""
                      }
                      alt="foto"
                    />
                  </div>
                  <div className={style.post_image_txt}>
                    <p>
                      Допустимые форматы изображения:
                      <br /> .jpeg, .png, .jpg
                    </p>
                    <label className={style.file_image}>
                      Загрузить
                      <input
                        ref={filePickerRef}
                        onChange={previewFile}
                        type="file"
                        accept="image/png, image/jpeg, image/gif"
                      />
                    </label>
                  </div>
                </div>
              </label>

              <label className={style.form_label}>
                Имя
                <input className={style.form_input} type="text" />
              </label>
              <label className={style.form_label}>
                Фамилия
                <input className={style.form_input} type="text" />
              </label>

              <label className={style.form_label}>
                Дата приема на работу
                <input
                  className={style.form_input}
                  type="date"
                  placeholder="ДД.ММ.ГГГГ"
                />
              </label>
              <label className={style.form_label}>
                Проекты
                <input
                  className={style.form_input}
                  type="number"
                  placeholder="24"
                />
              </label>
              <label className={style.form_label_max}>
                Отдел
                <select className={style.form_select}>
                  <option value="meeting room">Meeting room</option>
                  <option selected value="mini meeting room">
                    Mini meeting room
                  </option>
                </select>
              </label>

              <label className={style.form_label_max}>
                Профессия
                <input className={style.form_input} type="text" />
              </label>
              <label className={style.form_label_max}>
                Номер телефона
                <input className={style.form_input} type="phone" />
              </label>
            </form>
          </div>
          <div className={style.modal_footer}>
            <button
              onClick={() => setStatus(false)}
              type={"submit"}
              className={style.save_btn}
            >
              Сохранить
            </button>
            <button className={style.cancel_btn}>Отмена</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;
